import NSIdentity from "./NSIdentity";
import IdResolver from "./IdResolver";
import Namespace from "./Namespace";
import Ensure from "./Ensure";
export default class NSDictionary {
    constructor() {
        this._fqnObjectMap = {};
        this._idResolver = new IdResolver();
    }
    set(key, value) {
        this._fqnObjectMap[key.fqn] = value;
        this._idResolver.add(key);
    }
    delete(key) {
        if (this._fqnObjectMap[key.fqn] !== void 0) {
            delete this._fqnObjectMap[key.fqn];
            this._idResolver.remove(key);
            return true;
        }
        return false;
    }
    get(arg1) {
        if (!arg1) {
            throw new Error("NSDictionary.get() can not recieve args null or undefined.");
        }
        if (typeof arg1 === "string") {
            const fqn = Ensure.tobeFQN(arg1);
            if (fqn) {
                return this._fqnObjectMap[fqn];
            }
            const name = arg1.split(".");
            const res = this._idResolver.get(Namespace.defineByArray(name));
            // const namedMap = this._nameObjectMap[arg1];
            if (res.length === 0) {
                return null; // not exist.
            }
            if (res.length === 1) {
                return this._fqnObjectMap[res[0]];
            }
            else {
                throw new Error(`Specified tag name ${arg1} is ambiguous to identify.`);
            }
        }
        else {
            if (arg1 instanceof NSIdentity) {
                return this._fqnObjectMap[arg1.fqn];
            }
            else {
                if (arg1.namespaceURI) {
                    return this.get(arg1.namespaceURI + "." + arg1.localName);
                }
                return this.get(arg1.localName);
            }
        }
    }
    /**
     * Check if name has possibility of multiple values.
     * @param  {string}  name [description]
     * @return {boolean}      Whether the name has multiple values.
     */
    isAmbiguous(name) {
        return this._idResolver.get(Namespace.defineByArray(name.split("."))).length > 1;
    }
    has(name) {
        return this._idResolver.get(Namespace.defineByArray(name.split("."))).length !== 0;
    }
    pushDictionary(dict) {
        dict.forEach((value, keyFQN) => {
            const id = NSIdentity.fromFQN(keyFQN);
            this.set(id, value);
        });
        return this;
    }
    hasMatchingValue(name) {
        const resolver = new IdResolver();
        resolver.add(name);
        let match = void 0;
        for (let key in this._fqnObjectMap) {
            let v = resolver.get(Namespace.defineByArray(key.split(".")));
            if (v.length === 1) {
                if (match === void 0) {
                    match = key;
                }
                else {
                    throw new Error(`matching attribute is ambiguous. It has following possibilities ${match} ${key}`);
                }
            }
        }
        if (match) {
            return this._fqnObjectMap[match];
        }
        return void 0;
    }
    toArray() {
        const ret = [];
        Object.keys(this._fqnObjectMap).forEach(key => {
            ret.push(this._fqnObjectMap[key]);
        });
        return ret;
    }
    clone() {
        const dict = new NSDictionary();
        return dict.pushDictionary(this);
    }
    forEach(callback) {
        Object.keys(this._fqnObjectMap).forEach(key => {
            callback(this._fqnObjectMap[key], key);
        });
        return this;
    }
    map(callback) {
        const ret = new NSDictionary();
        this.forEach((val, fqn) => {
            const id = NSIdentity.fromFQN(fqn);
            ret.set(id, callback(val, fqn));
        });
        return ret;
    }
    clear() {
        this._fqnObjectMap = {};
        this._idResolver = new IdResolver();
    }
}



// WEBPACK FOOTER //
// ./src/Base/NSDictionary.ts